// extracted by mini-css-extract-plugin
module.exports = {"container":"label_container__Rts8g","fade-in":"label_fade-in__FxLJL"};